<div class="container">
    <div class="row from-top">
        <!-- Close -->
        <button type="button" class="close-button" (click)="dialogRef.close()">&times;</button>

        <!-- Titles -->
        <div class="col-md-12 text-center">
            <h1>{{'gen_change_avatar' | translate}}</h1>
        </div>

        <!-- Avatars -->
        <div class="col-6 col-md-2" *ngFor="let avatar of data?.avatars">
            <img class="avatar img-fluid" [src]="'assets/images/avatars/avatar' + avatar + '.png'"
                [ngClass]="{'selected-avatar': avatar == data.selected}" (click)="dialogRef.close(avatar)" />
        </div>
    </div>
</div>